
<template>
  <asd20-app-template
    :version="`${version}`"
    :back-link="referrer"
    :back-label="referrer.replace(/https?:\/\//, '')"
    title="Calendar Status"
    icon="calendar"
  >
    <template>
      <main>
        <div class="wrap">
          <asd20-viewport
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
            scrollable
            padded
          >
            <asd20-list
              v-for="(statuses, orgTitle) of statusesByOrg"
              :key="orgTitle"
              :headline="orgTitle"
              multi-column>

              <asd20-list-item
                v-for="cs in statuses"
                :key="cs.id"
                :label="`${cs.categories.length ? cs.categories.join(', ') + ': ' : ''}${cs.title}`"
                :description="`${cs.job && cs.job.end ? ('<em>' + cs.job.processedEvents + ' events processed</em> <br/>at ' + new Date(cs.job.end).toLocaleString()) : ''}`"
                :checked="!!(cs.job && cs.job.status)"
                align-top
                bordered
              />
            </asd20-list>
          </asd20-viewport>
          <Asd20Loader
            v-show="loading"
            size="lg"/>
        </div>
      </main>
    </template>
  </asd20-app-template>
</template>

<script>
// Helpers
import { get, sync } from 'vuex-pathify'
import  axios from 'axios'

// Components
import Asd20AppTemplate from '@asd20/ui/src/components/templates/Asd20AppTemplate'
import Asd20DistrictLogo from '@asd20/ui/src/components/atoms/Asd20DistrictLogo'
import Asd20Loader from '@asd20/ui/src/components/molecules/Asd20Loader'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20ListCategory from '@asd20/ui/src/components/molecules/Asd20ListCategory'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'

// Data
import { version } from '../../../package.json'

export default {
  name: 'HomePage',

  components: {
    Asd20AppTemplate,
    Asd20DistrictLogo,
    Asd20Viewport,
    Asd20Loader,
    Asd20ListItem,
    Asd20ListCategory,
    Asd20List
  },

  data: () => ({
    version,
    loading: false,
    calendarSubscriptions: []
  }),

  computed: {
    referrer: get('referrer'),

    statusesByOrg() {
      return this.calendarSubscriptions.reduce((a,cs, i, s) => {
        if (!cs.ownerOrganization) return
        if (!a[cs.ownerOrganization.title]) {
          a[cs.ownerOrganization.title] = []
          a[cs.ownerOrganization.title].push({
              ...cs,
              job: cs.syncJobs[0]
            })
        } else {
          a[cs.ownerOrganization.title].push({
              ...cs,
              job: cs.syncJobs[0]
            })
        }
        return a
      }, {})
    }
  },

  // Trigger fetch on route enter
  mounted() {
    this.fetchData()
  },

  methods: {
    // Load data needed for the view
    async fetchData() {
      this.loading = true
      const { data: response } = await axios.post(process.env.VUE_APP_GRAPHQL_ENDPOINT, {
        query: `
        {
          calendarSubscriptions(order_by: { ownerOrganization: { title: asc }, categories: asc, title: asc }) {
            ownerOrganization {
              title
            }
            categories
            title
            syncJobs(limit: 1, order_by: { start: desc }) {
              id
              status
              start
              end
              processedEvents
            }
          }
        }`
      })

      this.calendarSubscriptions = response.data && response.data.calendarSubscriptions

      this.loading = false
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';

main {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  .wrap {
    position: relative;
    flex-grow: 1;
  }

  h2 {
    margin-bottom: -1rem;
  }
}

@media (min-width: 768px) {
  main {
  }
}

</style>
